module.exports = __webpack_public_path__ + "img/memorial-statue.cd37fa8d.webp";